import { render, staticRenderFns } from "./newwork.vue?vue&type=template&id=fc381d24&scoped=true&"
import script from "./newwork.vue?vue&type=script&lang=js&"
export * from "./newwork.vue?vue&type=script&lang=js&"
import style0 from "./newwork.vue?vue&type=style&index=0&id=fc381d24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc381d24",
  null
  
)

export default component.exports